<!DOCTYPE html>
<html class="no-js" lang="">
<head>
  <meta charset="utf-8"/>
  <meta http-equiv="x-ua-compatible" content="ie=edge"/>
  <title>Olas verdes</title>
  <meta name="description" content="Página asociacion cannabica - Olas Verdes"/>
  <meta name="viewport" content="width=device-width, initial-scale=1"/>
</head>
  <body>
    <app-header [menuData]="menuDataHeader">
    </app-header>
    <ng-container>
      <router-outlet></router-outlet>
    </ng-container>
    <!-- <ng-template #noApiToken>
      <app-no-api-token></app-no-api-token>
    </ng-template> -->
    <app-footer></app-footer>
  </body>
</html>
